import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickSingleQuery } from "../types";
import { getApi } from "../apiPath";
import { axiosClient } from "../clients";

import type { IMembers } from "./routeType";

const { key, getPath } = getApi("members.get");

type IExtractedRouteType = IMembers["memberProfileSingleRetrieve"];

export type IGetMember = IPickSingleQuery<IExtractedRouteType>;

const getMember: Fetcher<IGetMember["response"], IGetMember["variables"]> = ({
  memberId,
  ...params
}) => {
  return axiosClient.get(getPath({ memberId }), { params });
};

export const useGetMember = createQuery({
  queryKey: [key],
  fetcher: getMember,
});
